// Helper, that is used to forcibly finalize all promises
// in thunk before running matcher against state.
import { getConfig } from '@edx/frontend-platform';

export const executeThunk = async (thunk, dispatch, getState) => {
  await thunk(dispatch, getState);
  await new Promise(setImmediate);
};

// Utility function for appending the browser timezone to the url
// Can be used on the backend when the user timezone is not set in the user account
export const appendBrowserTimezoneToUrl = (url) => {
  const browserTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const urlObject = new URL(url);
  if (browserTimezone) {
    urlObject.searchParams.append('browser_timezone', browserTimezone);
  }
  return urlObject.href;
};

export const getLoginRedirectUrl = (redirectUrl = undefined) => {
  const config = getConfig();
  const loginRedirectUrl = new URL(config.LOGIN_URL);
  if (redirectUrl) {
    loginRedirectUrl.searchParams.set('next', redirectUrl);
  }
  return loginRedirectUrl.href;
};

export const doLoginRedirect = () => {
  window.location.href = getLoginRedirectUrl(window.location.href);
};

// Needed, because there are custom certificates
export const filterDates = (dates) => dates.filter(date => date.date_type !== 'verified-upgrade-deadline');
